import axios from 'axios'

function coalescePatientList (data) {
  if (data == null) return [];
  if (Array.isArray(data)) return data;
  if (typeof data === "object") {
    if (Array.isArray(data.result)) return data.result;
    if (Array.isArray(data.patients)) return data.patients;
    if (Array.isArray(data.data)) return data.data;
    if (Array.isArray(data.items)) return data.items;
    if (Array.isArray(data.records)) return data.records;
  }
  return [];
}

export async function getPatients(patientId = "") {
  return fetchPatientList("/a/get-patients", patientId);
}

/** Patients with legacy-dataset trials; `[]` for every account without them. */
export async function getLegacyPatients(patientId = "") {
  return fetchPatientList("/a/legacy/get-patients", patientId);
}

function fetchPatientList(route, patientId) {
  const token = localStorage.getItem("token");
  return fetch(window.SERVER_URL + route + "?patientId=" + patientId, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
    },
  })
    .then(async (response) => {
      const data = await response.json().catch(function () { return null; });
      if (response.ok === false) {
        return [];
      }
      return coalescePatientList(data);
    })
    .catch((err) => {
      console.log(err);
      return [];
    });
}
export async function deletePatient(patientId) {
  const token = localStorage.getItem("token");
  return fetch(window.SERVER_URL + "/a/delete-patient?patientId=" + patientId, {
    method: "DELETE",
    headers: {
      Authorization: "Bearer " + token,
    },
  }).then((res) => res.json());
}

/** Move a single patient to trash (soft delete; purged after 30 days). */
export async function trashPatient(patientId) {
  const token = localStorage.getItem("token");
  return axios.post(
    window.SERVER_URL + "/a/trash-patient",
    { patientId },
    { headers: { Authorization: "Bearer " + token, "Content-Type": "application/json" } }
  ).then((res) => res.data).catch((err) => {
    console.error("Error trashing patient:", err);
    throw err;
  });
}

/** Move multiple patients to trash. Falls back to hard delete if backend does not have trash endpoint (404). */
export async function trashPatients(ids) {
  const idList = Array.isArray(ids) ? ids : [];
  if (idList.length === 0) return { ok: true, trashed: 0 };
  try {
    const res = await axios.post(
      window.SERVER_URL + "/a/trash-patients",
      { ids: idList },
      { headers: { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json" } }
    );
    return res.data;
  } catch (err) {
    if (err?.response?.status === 404) {
      for (const patientId of idList) {
        try {
          await deletePatient(patientId);
        } catch (e) {
          console.error("Error deleting patient:", patientId, e);
        }
      }
      return { ok: true, trashed: idList.length };
    }
    console.error("Error trashing patients:", err);
    throw err;
  }
}
export async function updatePatient(data) {
  const token = localStorage.getItem("token");
  return fetch(window.SERVER_URL + "/a/update-patient", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .catch((err) => console.log(err));
}
export async function getPatientSessions(patientID) {
  const token = localStorage.getItem("token");
  return fetch(window.SERVER_URL + `/a/get-sessions?patient=${patientID}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((err) => console.log(err));
}

// this function is used by outdated code
// export async function getPatientTags(patientID) {
//     return fetch(`/api/get-tags-patient?patient=${patientID}`)
//            .then(res => res.json())
//            .catch(err => console.log(err))
// }

export async function createNewPatient(data) {
  const token = localStorage.getItem("token");
  return axios.post(window.SERVER_URL + "/a/create-patient",JSON.stringify(data), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  })
    .then((res) => res.json())
    .catch((err) => console.log(err));
}

export async function updatePatientTags(patientID, patientNotes) {
  const token = localStorage.getItem("token");
  return fetch(window.SERVER_URL + "/a/update-patient-tags", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify({
      patient_id: patientID,
      patient_notes: patientNotes,
    }),
  })
    .then((res) => res.json())
    .catch((err) => console.log(err));
}
